export enum StrangersType {
  PERSON = 'PERSON',
  ORGANIZATION = 'ORGANIZATION',
  PERSONRUS = 'PERSONRUS',
  ORGANIZATIONRUS = 'ORGANIZATIONRUS',
  UNDEFINED = 'UNDEFINED'
}
export enum StrangersOwnerType {
  PERSON = 'PERSON',
  APPLICANT = 'APPLICANT',
  LEGAL = 'LEGAL',
}
